class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  connectedCallback() {
    if (window.innerWidth >= 990) {
      this.handleMenuEffect();
    }

    window.addEventListener('resize', (e) => {
      if (window.innerWidth >= 990) {
        this.handleMenuEffect();
      }
    })
  }

  handleMenuEffect() {
    this.mainDetailsToggle.addEventListener('mouseenter', () => {
      this.mainDetailsToggle.setAttribute('open', true);
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
      this.mainDetailsToggle.querySelector('summary').focus();
    });
    this.mainDetailsToggle.addEventListener('mouseleave', () => {
      this.mainDetailsToggle.removeAttribute('open');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      this.mainDetailsToggle.querySelector('summary').blur();
    });

    // Detected position of item in menu DOM to move line background
    let listItem = this.header.querySelectorAll('.header__inline-menu > .list-menu > li');
    let positionListMenu = 0;
    let clearTimeout = setTimeout(() => { // Fix bug sometime getBoundingClientRect() return incorrect value
      positionListMenu = this.header.querySelector('.header__inline-menu > .list-menu').getBoundingClientRect().left;
    }, 500);

    listItem.forEach((item) => {
      item.addEventListener('mouseenter', (e) => {
        let itemWidth = e.target.offsetWidth;
        let itemLeft = e.target.getBoundingClientRect().left - positionListMenu;
        this.header.querySelector('.header__inline-menu > .list-menu > .line').style.width = `${itemWidth}px`;
        this.header.querySelector('.header__inline-menu > .list-menu > .line').style.left = `${itemLeft}px`;
        this.header.querySelector('.header__inline-menu > .list-menu > .line').style.opacity = 1;
      });

      item.addEventListener('mouseleave', (e) => {
        this.header.querySelector('.header__inline-menu > .list-menu > .line').style.opacity = 0;
        listItem.forEach((item) => {
          this.checkItemAcitive(item);
        })
      })

      this.checkItemAcitive(item);
    });
  }

  checkItemAcitive(item) {
    if(item.classList.contains('link__item-active')){
      let itemWidth = item.offsetWidth;
      let itemLeft = item.getBoundingClientRect().left - document.querySelector('.header__inline-menu > .list-menu').getBoundingClientRect().left;
      this.header.querySelector('.header__inline-menu > .list-menu > .line').style.width = `${itemWidth}px`;
      this.header.querySelector('.header__inline-menu > .list-menu > .line').style.left = `${itemLeft}px`;
      this.header.querySelector('.header__inline-menu > .list-menu > .line').style.opacity = 1;
    }
  }

}

customElements.define('header-menu', HeaderMenu);
